import React, { Component } from 'react';
import { toastr } from 'react-redux-toastr';
import Box from '../../common/template/box';
import api from '../../api';
import Requisition from '../../utils/requisitions/requisition';
import CONSTS from '../../config/consts';
import Language from '../../config/language';
import ModalCaixa from './modal-caixa';

export default class PerfisServicos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props.data
    }
    this.onChangeSelect = this.onChangeSelect.bind(this);
    this.openModal = this.openModal.bind(this);
    this.afterOpenModal = this.afterOpenModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.onCreate = this.onCreate.bind(this);
  }

  componentDidMount(){
  }

  openModal(modal, item) {

    const data = {
      [modal]: true,
      itemModal: item
    };

    this.setState(data);
  }

  afterOpenModal() {
  }

  closeModal(modal, data) {
    const state = {[modal]: false};
    let histUpdated = [];

    if(data && data.servico){
      if (data.type && data.type === "update") {
        histUpdated = this.state.historico.map(i =>
          {
            return i.id === data.servico.id ? data.servico : i;
          }
        );
      }else{
        histUpdated = [...this.state.historico, data.servico];
      }
      state.historico = histUpdated;
    }
    this.setState(state);
  }

  onChangeSelect(val, name){
    const { token } = this.props;
    const self = this;
    const data = {plano: this.props.plano, servico: val.value};

    Requisition({
      header: {
        [CONSTS.API_KEY ]: CONSTS.API_KEY_VALUE,
        'Auth' : 'Bearer '+token
      },
      type: 'post',
      url: `${api.API_URL}${api.API.planosServicos.create}`,
      data: data,
      success: response => {
        const data = response.data;
        if(data){
          if(data.status){
            toastr.success(Language.atencao, data.msg);
            self.addServico(data.data);
          }else{
            toastr.warning(Language.atencao, data.msg);
          }
        }else{
          toastr.error(Language.erroTitle, Language.erro01);
        }
      },
      error: response => {
        toastr.error(Language.erroTitle, Language.erro02);
      }
    });
  }

  addServico(item){
    const historico = [...this.state.historico,...item];
    this.setState({
      historico,
      servico: null
    });
    this.openModal('modalServico', item[0].id);
  }

  removeItem(id){
    const { token } = this.props;
    const self = this;

    Requisition({
      header: {
        [CONSTS.API_KEY ]: CONSTS.API_KEY_VALUE,
        'Auth' : 'Bearer '+token
      },
      type: 'delete',
      url: `${api.API_URL}${api.API.caixaItens.delete.replace(/{id}/,id)}`,
      data: {},
      success: response => {
        const data = response.data;
        if(data){
          if(data.status){
            toastr.success(Language.atencao, data.msg);
            self.removeItemItem(id);
          }else{
            toastr.warning(Language.atencao, data.msg);
          }
        }else{
          toastr.error(Language.erroTitle, Language.erro01);
        }
      },
      error: response => {
        toastr.error(Language.erroTitle, Language.erro02);
      }
    });
  }

  removeItemItem(id){
    const arr = this.state.historico.filter((value, index, arr) => {
      return value.id !== id;
    });
    this.setState({
      historico: arr
    });
  }

  renderRows() {
      const list = this.state.historico || [];
      return list.map(bc => (
        <tr key={bc.id}>
            <td><span className={`${"badge "}${Number(bc.tipo.value)===1 ? "bg-blue" : "bg-red"}`}>{bc.tipo.label}</span></td>
            <td>{bc.tipo_caixa ? bc.tipo_caixa.label : ''}</td>
            <td>{bc.usuario}</td>
            <td>{bc.valor ? bc.valor.formated : null}</td>
            <td>{bc.cliente || '-'}</td>
            <td>{bc.venda || '-'}</td>
            {
              !this.props.readOnly
              ? <td>
                  <div>
                    <button type="button" className='btn btn-warning' onClick={() => this.openModal('modalCaixa', bc.id)}>
                        <i className='fa fa-pencil'></i>
                    </button>
                    <button type="button" className='btn btn-danger' onClick={() => this.removeItem(bc.id)}>
                        <i className='fa fa-trash-o'></i>
                    </button>
                  </div>
                </td>
                : null
            }
        </tr>
      ));
  }

  onCreate(itens){
    this.setState({modalCaixa: false, ...itens});
  }

  render(){
    return(
      <div id="content-ajax">
        <Box classes="box-success" title="Financeiro">
          <ModalCaixa
            token={this.props.token}
            className='Modal_Caixa'
            isOpen={this.state['modalCaixa']}
            onAfterOpen={this.afterOpenModal}
            onRequestClose={()=>this.closeModal('modalCaixa')}
            item={this.props.item}
            onCreate={data => this.onCreate(data)}
            id={this.state.itemModal}
          />
          <div>
          {
            !this.props.readOnly ? <button type="button" className="btn btn-block btn-success" onClick={()=>this.openModal('modalCaixa')}>
              <i className="fa fa-plus"></i>  Novo item
            </button> : null
          }

            <br />
            <br />
          </div>
          <table className='table'>
              <thead>
                  <tr>
                    <th>Entradas</th>
                    <th className="">Saídas</th>
                    <th className="">Total</th>
                  </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{this.state.entradas.formated}</td>
                  <td className="">{this.state.saidas.formated}</td>
                  <td className="">{this.state.total.formated}</td>
                </tr>
              </tbody>
          </table>
          <br />
          <br />
          <div>
            <table className='table'>
                <thead>
                    <tr>
                      <th>Tipo</th>
                      <th className="">Modalidade</th>
                      <th className="">Criado por</th>
                      <th className="">Valor</th>
                      <th className="">Cliente</th>
                      <th className="">Id Venda</th>
                      { !this.props.readOnly ? <th className='table-actions'></th> : null}
                    </tr>
                </thead>
                <tbody>
                    {this.renderRows()}
                </tbody>
            </table>
          </div>
        </Box>

      </div>
    );
  }
}
